
  import { defineComponent, PropType } from 'vue';

  import FilterFactory from '../Filter/FilterFactory.vue';
  import { TFilter, TFilterConfig } from '../Filter/types/filter';
  import TableComponent from './TableComponent.vue';
  import { TSortParams, TTableWithOuterFilterConfig } from './types/tableTypes';

  export default defineComponent({
    name: 'TableWithOuterFilter',
    components: {
      FilterFactory,
      TableComponent,
    },
    emits: ['searchFilter'],
    data(): {
      tableParams: TFilter;
      sortParams: TSortParams | null;
    } {
      return {
        tableParams: {},
        sortParams: null,
      };
    },
    props: {
      tableConfig: {
        type: Object as PropType<TTableWithOuterFilterConfig<any>>,
        required: true,
      },
      defaultFilter: {
        type: Object as PropType<TFilter>,
        default: () => ({}),
      },
      filtersConfig: {
        type: Array as PropType<TFilterConfig[]>,
        required: true,
      },
      tableClass: {
        type: String,
      },
      isLifeSync: {
        type: Boolean,
        default: false,
      },
      //TODO: привести к единообразию на проекте
      //VES - показать. МПК и мнт - применить
      selectButtonText: {
        type: String,
        default: 'Показать',
      },
    },
    created() {
      this.tableParams = this.defaultFilter ?? {};
    },
    computed: {
      getTableParams() {
        return {
          ...this.tableParams,
          ...this.tableConfig.params,
        };
      },
      getSlotFilter(): TFilter {
        return {
          ...this.tableParams,
          ...this.sortParams,
        };
      },
    },
    methods: {
      searchFilter(filter: TFilter) {
        this.tableParams = filter;
        this.$emit('searchFilter', filter);
      },
      onSortChange(sort: TSortParams | null) {
        this.sortParams = sort;
      },
      onResetFilter() {
        const tableComponent = this.$refs.tableComponent as InstanceType<typeof TableComponent> | undefined;
        tableComponent?.resetSort();
      },
      updateFilter(filter: TFilter) {
        if (!this.isLifeSync) return;
        this.searchFilter(filter);
      },
    },
  });
